import { STRING_getInstance7xungxdjbzv as STRING_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import {
  DataClassPathSelf18kqeagzkbefr as DataClassPathSelf,
  DataClassPathPartial2ywkg16gqhuu6 as DataClassPathPartial,
  DataClassPath2zx7tvblx35e3 as DataClassPath,
  DataClassPathOfType22v56nemy4d4a as DataClassPathOfType,
  DataClassPathList1wm0kncx8ym4m as DataClassPathList,
  DataClassPathAccess3qupo9g6dhbeb as DataClassPathAccess,
  DataClassPathNotNull3k4t7brymixty as DataClassPathNotNull,
} from './DataClassPath.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  removeSuffix3d61x5lsuvuho as removeSuffix,
  startsWith1bgirhbedtv2y as startsWith,
  endsWith278181ii8uuo as endsWith,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { substringiqarkczpya5m as substring } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import {
  get_serializableOptions2omofumtgto14 as get_serializableOptions,
  SerializableProperty3cbm268cpjr8q as SerializableProperty,
  get_serializableProperties1162nosnaangd as get_serializableProperties,
} from './SerializableProperty.mjs';
import {
  _SealedTypeDiscriminator___init__impl__jf77jnb2draso4x6g as _SealedTypeDiscriminator___init__impl__jf77jn,
  _SealedTypeDiscriminator___get_serialName__impl__x46m55cpdzns363t1u as _SealedTypeDiscriminator___get_serialName__impl__x46m55,
  variantShortNamey38i8usgp8vx as variantShortName,
} from './SealedTypeDiscriminator.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  listElement3jy3tr2z6og1q as listElement,
  nullElement39ujy5fzowmto as nullElement,
  KSerializerKey32hf92q4tsy3p as KSerializerKey,
} from './SerializationHelpers.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { KSerializerWithDefault3c244bl47fg5p as KSerializerWithDefault } from './Defaults.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClassPathSerializerClass;
function DataClassPathSerializer() {
  if (DataClassPathSerializerClass === VOID) {
    class $ {
      constructor(inner) {
        this.inner_1 = inner;
        this.descriptor_1 = PrimitiveSerialDescriptor('com.lightningkite.services.database.DataClassPathPartial', STRING_getInstance());
      }
      get_default_qtagd4_k$() {
        return new (DataClassPathSelf())(this.inner_1);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      deserialize_sy6x50_k$(decoder) {
        var value = decoder.decodeString_x3hxsx_k$();
        return this.fromString_g5hge7_k$(value);
      }
      serialize_vzfwno_k$(encoder, value) {
        encoder.encodeString_424b5v_k$(value.toString());
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_vzfwno_k$(encoder, value instanceof DataClassPathPartial() ? value : THROW_CCE());
      }
      fromString_g5hge7_k$(value) {
        var current = null;
        var currentSerializer = this.inner_1;
        var valueParts = splitPathSegments(value);
        var iterator = valueParts.iterator_jk1svi_k$();
        var index = 0;
        $l$loop_1: while (iterator.hasNext_bitz1p_k$()) {
          var index_0 = index;
          index = index + 1 | 0;
          var part = iterator.next_20eer_k$();
          var name = removeSuffix(part, '?');
          if (name === 'this')
            continue $l$loop_1;
          if (startsWith(name, _Char___init__impl__6a9atx(91)) && endsWith(name, _Char___init__impl__6a9atx(93))) {
            var typeName = substring(name, 1, name.length - 1 | 0);
            var tmp0_safe_receiver = get_serializableOptions(currentSerializer);
            var tmp;
            if (tmp0_safe_receiver == null) {
              tmp = null;
            } else {
              // Inline function 'kotlin.collections.find' call
              var tmp$ret$1;
              $l$block: {
                // Inline function 'kotlin.collections.firstOrNull' call
                var inductionVariable = 0;
                var last = tmp0_safe_receiver.length;
                while (inductionVariable < last) {
                  var element = tmp0_safe_receiver[inductionVariable];
                  inductionVariable = inductionVariable + 1 | 0;
                  var discriminator = _SealedTypeDiscriminator___init__impl__jf77jn(element.serializer_1);
                  var serialName = _SealedTypeDiscriminator___get_serialName__impl__x46m55(discriminator);
                  var tmp_0;
                  var tmp_1;
                  if (serialName === typeName) {
                    tmp_1 = true;
                  } else {
                    tmp_1 = variantShortName(isInterface(currentSerializer, KSerializer()) ? currentSerializer : THROW_CCE(), discriminator) === typeName;
                  }
                  if (tmp_1) {
                    tmp_0 = true;
                  } else {
                    tmp_0 = element.secondaryNames_1.contains_aljjnj_k$(typeName);
                  }
                  if (tmp_0) {
                    tmp$ret$1 = element;
                    break $l$block;
                  }
                }
                tmp$ret$1 = null;
              }
              tmp = tmp$ret$1;
            }
            var tmp1_elvis_lhs = tmp;
            var tmp_2;
            if (tmp1_elvis_lhs == null) {
              throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$("'" + typeName + "' is not a variant of " + currentSerializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$());
            } else {
              tmp_2 = tmp1_elvis_lhs;
            }
            var option = tmp_2;
            var tmp2_elvis_lhs = current;
            var tmp_3 = tmp2_elvis_lhs == null ? new (DataClassPathSelf())(this.inner_1) : tmp2_elvis_lhs;
            current = new (DataClassPathOfType())(tmp_3 instanceof DataClassPath() ? tmp_3 : THROW_CCE(), option.serializer_1);
            currentSerializer = option.serializer_1;
            continue $l$loop_1;
          }
          if (name === '*') {
            var tmp3_elvis_lhs = current;
            var tmp_4;
            if (tmp3_elvis_lhs == null) {
              throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$("'*' cannot be the root of a path");
            } else {
              tmp_4 = tmp3_elvis_lhs;
            }
            var c = tmp_4;
            if (!(listElement(currentSerializer) == null)) {
              current = new (DataClassPathList())(c instanceof DataClassPath() ? c : THROW_CCE());
              currentSerializer = ensureNotNull(listElement(currentSerializer));
            } else {
              throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$("'*' used on non-collection type " + currentSerializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$());
            }
            continue $l$loop_1;
          }
          var tmp_5;
          try {
            tmp_5 = Companion_getInstance().get_3ritsm_k$(currentSerializer).invoke_lt562m_k$(name);
          } catch ($p) {
            var tmp_6;
            if ($p instanceof IllegalStateException()) {
              var e = $p;
              throw SerializationException().new_kotlinx_serialization_SerializationException_pjmzgo_k$(e.message, e);
            } else {
              throw $p;
            }
          }
          var prop = tmp_5;
          currentSerializer = prop.get_serializer_u29zhh_k$();
          var c_0 = current;
          var tmp_7;
          if (c_0 == null) {
            var tmp_8 = new (DataClassPathSelf())(this.inner_1);
            tmp_7 = new (DataClassPathAccess())(tmp_8, isInterface(prop, SerializableProperty()) ? prop : THROW_CCE());
          } else {
            var tmp_9 = c_0 instanceof DataClassPath() ? c_0 : THROW_CCE();
            tmp_7 = new (DataClassPathAccess())(tmp_9, isInterface(prop, SerializableProperty()) ? prop : THROW_CCE());
          }
          current = tmp_7;
          if (endsWith(part, _Char___init__impl__6a9atx(63)) || (prop.get_serializer_u29zhh_k$().get_descriptor_wjt6a0_k$().get_isNullable_67sy7o_k$() && !(index_0 === get_lastIndex(valueParts)))) {
            current = new (DataClassPathNotNull())(current instanceof DataClassPath() ? current : THROW_CCE());
            var tmp4_elvis_lhs = nullElement(currentSerializer);
            var tmp_10;
            if (tmp4_elvis_lhs == null) {
              throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$(prop.get_name_woqyms_k$() + ' is not nullable');
            } else {
              tmp_10 = tmp4_elvis_lhs;
            }
            currentSerializer = tmp_10;
          }
        }
        var tmp5_elvis_lhs = current;
        return tmp5_elvis_lhs == null ? new (DataClassPathSelf())(this.inner_1) : tmp5_elvis_lhs;
      }
    }
    initMetadataForClass($, 'DataClassPathSerializer', VOID, VOID, [KSerializerWithDefault()]);
    DataClassPathSerializerClass = $;
  }
  return DataClassPathSerializerClass;
}
function splitPathSegments(_this__u8e3s4) {
  var parts = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var current = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  var depth = 0;
  var inductionVariable = 0;
  var last = _this__u8e3s4.length;
  $l$loop: while (inductionVariable < last) {
    var c = charCodeAt(_this__u8e3s4, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    if (c === _Char___init__impl__6a9atx(91)) {
      depth = depth + 1 | 0;
    } else if (c === _Char___init__impl__6a9atx(93)) {
      depth = depth - 1 | 0;
    } else if (c === _Char___init__impl__6a9atx(46) && depth === 0) {
      parts.add_utx5q5_k$(current.toString());
      current.clear_1keqml_k$();
      continue $l$loop;
    }
    current.append_58al37_k$(c);
  }
  parts.add_utx5q5_k$(current.toString());
  return parts;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.existing_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
      }
      get_3ritsm_k$(serializer) {
        var tmp0 = this.existing_1;
        // Inline function 'kotlin.collections.getOrPut' call
        var key = KSerializerKey().new_com_lightningkite_services_database_KSerializerKey_4fta1q_k$(serializer);
        var value = tmp0.get_wei43m_k$(key);
        var tmp;
        if (value == null) {
          var answer = new (SerializablePropertyParser())(serializer);
          tmp0.put_4fpzoq_k$(key, answer);
          tmp = answer;
        } else {
          tmp = value;
        }
        var tmp_0 = tmp;
        return tmp_0 instanceof SerializablePropertyParser() ? tmp_0 : THROW_CCE();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var SerializablePropertyParserClass;
function SerializablePropertyParser() {
  if (SerializablePropertyParserClass === VOID) {
    class $ {
      constructor(serializer) {
        Companion_getInstance();
        this.serializer_1 = serializer;
        var tmp = this;
        // Inline function 'kotlin.run' call
        var tmp0_elvis_lhs = get_serializableProperties(this.serializer_1);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$(this.serializer_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() + ' does not have any serializable properties');
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        // Inline function 'kotlin.collections.associateBy' call
        var this_0 = tmp_0;
        var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
        var inductionVariable = 0;
        var last = this_0.length;
        while (inductionVariable < last) {
          var element = this_0[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$4 = element.get_name_woqyms_k$();
          destination.put_4fpzoq_k$(tmp$ret$4, element);
        }
        tmp.children_1 = destination;
      }
      invoke_lt562m_k$(key) {
        var tmp0_elvis_lhs = this.children_1.get_wei43m_k$(key);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$("Could find no property with name '" + key + "' on " + this.serializer_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$());
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'SerializablePropertyParser');
    SerializablePropertyParserClass = $;
  }
  return SerializablePropertyParserClass;
}
//region block: exports
export {
  DataClassPathSerializer as DataClassPathSerializer2aqs8pcwb13zn,
};
//endregion

//# sourceMappingURL=DataClassPathSerializer.mjs.map
